import {
  Component,
  OnInit,
  Injectable,
  Input,
  EventEmitter,
  ViewChild,
  ComponentFactoryResolver,
  Injector,
  ViewContainerRef,
  HostListener,
} from "@angular/core";
import { ModalController, MenuController, IonContent } from "@ionic/angular";
import { MediaPage } from "src/app/modals/media/media.page";
import { promise } from "protractor";
import { ChangeDetectorRef, ElementRef } from "@angular/core";
import { Router } from "@angular/router";

export interface AppPage {
  title: string;
  url: string;
  icon: string;
  menuItem: boolean;
}

@Component({
  selector: "app-media",
  templateUrl: "./media.component.html",
  styleUrls: ["./media.component.scss"],
})
@Injectable({
  providedIn: "root",
})
export class MediaComponent implements OnInit {
  @ViewChild("componentContainer", { read: ViewContainerRef })
  componentContainer: ViewContainerRef;

  @Input() someData: string;
  @ViewChild(IonContent, { static: true }) content: IonContent;
  sections: string[] = [
    "Introduction",
    "Home",
    "Training",
    "People",
    "Lessons",
    "Contractors",
    "Administration",
    "Settings",
  ];
  currentSectionIndex: number = 0;
  selectedTab: string = "menuPage";
  selectedComponent: any;
  selectedMenuItemTitle: string = "Home";

  appHeaderEmitter: EventEmitter<string> = new EventEmitter();
  selectedPage: AppPage;

  constructor(
    public modalController: ModalController,
    private menuCtrl: MenuController,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {

  }



  async show(
    heading: string, additionalText: string
  ) {
    var promise = new Promise(async (resolve, reject) => {
      var paramObject = {
        heading: heading,
        additionalText: additionalText
      };

      const media = await this.modalController.create({
        component: MediaPage,
        componentProps: {
          paramObject: paramObject,
        },
        cssClass: "modal-super-fullscreen",
      });

      media.onDidDismiss().then(async (dataReturned) => {
        resolve(dataReturned);
      });
      media.present();
    });
    return promise;
  }
}
function ngOnInit() {
  throw new Error("Function not implemented.");
}

function dismissMedia() {
  throw new Error("Function not implemented.");
}

